export default "__VITE_ASSET__VanarBtY__"